import { Col, Form, Input, Row } from "antd";
import React, { useEffect } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import {
  convertFileToBase64,
  showNotitfication,
} from "../../../../components/utils/utils";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import { useState } from "react";
import { setResModel, setResIds } from "../../../../apis/slices/ratingSlice";
import {
  AddNoteToStudent,
  getSchoolObservations,
} from "../../../../apis/actions/school.actions";
interface AddNoteProps {
  students: any;
  setIsModalVisible: (v: boolean) => void;
  isModalVisible: boolean;
  studentId?: any;
}

const AddNote = ({
  students,
  setIsModalVisible,
  isModalVisible,
  studentId,
}: AddNoteProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    form.resetFields();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible]);
  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[], fieldName: string) => {
    const validFilesData = await Promise.all(
      fileList.map(async (fileWrapper: any) => {
        const file = fileWrapper.originFileObj;

        if (file) {
          try {
            const base64 = await convertFileToBase64(file);
            return {
              filename: file.name,
              data: base64,
            };
          } catch (error) {
            console.error("Error converting file to Base64:", error);
            return null;
          }
        }
        return null;
      })
    );

    // Filter out null values and retain only valid file data
    const filteredData = validFilesData.filter(
      (file) => file?.data && file?.filename
    );

    // Update the form value with filtered files
    form.setFieldsValue({
      [fieldName]: filteredData,
    });
  };

  const onFinish = async () => {
    try {
      await form.validateFields();
      setIsSubmitting(true);

      const FormValues = form.getFieldsValue();

      const requestsFormData = {
        ...FormValues,
        beneficiary_id: studentId ? studentId : form.getFieldValue("beneficiary_id").value,
      };

      dispatch(AddNoteToStudent(requestsFormData)).then((result: any) => {
        const request = result?.payload?.result;
        if (request?.code === 200) {
          dispatch(setResModel(request?.res_model));
          dispatch(setResIds([request?.request_id]));
          showNotitfication(request?.message, "success", dispatch);
          form.resetFields();
          setIsModalVisible(false);
          dispatch(getSchoolObservations());
        } else {
          showNotitfication(result?.payload?.error?.data?.message, "error");
          setIsModalVisible(false);
        }
        setIsSubmitting(false);
      });
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
    }
  };

  return (
    <ModalComponent
      title=""
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      closeOnOutsideClick={true}
      width={800}
      centered={true}
      modalStyle={{ top: -200 }}
    >
      <Row justify={"center"}>
        <p className="takaful--confirm-logout"> إضافة ملاحظة</p>
      </Row>
      <Form
        dir="rtl"
        form={form}
        layout="vertical"
        style={{ paddingTop: "1.5rem" }}
      >
        <Row gutter={16}>
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="beneficiary_id"
              label="الطالب(ة)"
              rules={[
                ({ getFieldValue }) => ({
                  required: !studentId, // Only required if studentId is undefined
                  message: "الرجاء تعبئة الحقل",
                }),
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Selects
                options={students}
                className="takaful--request-select"
                value={
                  studentId
                    ? {
                        label: students.find((s :any) => s.id === studentId)?.name,
                        value: studentId,
                      }
                    : undefined
                }
              onChange={(e) => {
                form.setFieldsValue({
                  beneficiary_id: e,
                });
              }}
                disabled={!!studentId}
              />{" "}
            </Form.Item>
          </Col>
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="observation"
              label="الملاحظة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <Input.TextArea
                style={{ height: "2.5rem" }}
                placeholder="أدخل الملاحظة"
              />
            </Form.Item>
          </Col>

          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="attachment_ids"
              label="المرفقات"
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <UploadInput
                accept="*"
                text="المرفقات"
                icon={<UploadOutlined />}
                multiple={true}
                maxCount={5}
                onChange={(fileList) =>
                  handleFileChange(fileList, "attachment_ids")
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
            <PrimaryButton
              disabled={isSubmitting}
              loading={isSubmitting}
              style={{ width: "100%" }}
              onClick={() => {
                onFinish();
              }}
              title="إرسال"
            />
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default AddNote;
